module.exports = __webpack_public_path__ + "static/media/news-head.8183c4ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-head.png
// module id = 841
// module chunks = 2